export const analyticsMethods = [
	'trackSubmit',
	'trackClick',
	'trackLink',
	'trackForm',
	'pageview',
	'identify',
	'reset',
	'group',
	'track',
	'ready',
	'alias',
	'debug',
	'page',
	'once',
	'off',
	'on',
	'addSourceMiddleware',
	'addIntegrationMiddleware',
	'setAnonymousId',
	'addDestinationMiddleware',
]

// https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/custom-proxy/
export const cdnURL = 'https://seg-cdn.birdeatsbug.com'

export const apiHost = 'seg-api.birdeatsbug.com/v1'

export const integrations = {'Segment.io': {apiHost}}

// https://segment-docs.netlify.app/docs/connections/sources/catalog/libraries/website/javascript/middleware/
// NOTE: the middlewares are replicated in the browser extension in `frontend/extension/src/utils/analytics.js` and need to be kept in-sync manually
export const middleware = function ({payload, next}) {
	// Don't send anonymous events to Customer.io, to prevent Customer.io to contain entries without email,
	// see https://segment-docs.netlify.app/docs/guides/filtering-data/#filtering-with-the-integrations-object
	if (!payload.obj.userId && payload.obj.integrations) {
		payload.obj.integrations['Customer.io'] = false
	}
	// Anonymize IP address, see:
	// https://segment-docs.netlify.app/docs/connections/sources/catalog/libraries/website/javascript/identity/#anonymizing-ip
	if (payload.obj.context) payload.obj.context.ip = '0.0.0.0'
	next(payload)
}
